function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.204 20h9.592c.86 0 1.319-1.012.753-1.659l-4.796-5.48a1 1 0 00-1.506 0l-4.796 5.48c-.566.647-.106 1.659.753 1.659z",
  fill: "#29354C"
});

var SvgIconIndexUp = function SvgIconIndexUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjIwMzggMjBMMjAuNzk2MiAyMEMyMS42NTU0IDIwIDIyLjExNDYgMTguOTg4MSAyMS41NDg4IDE4LjM0MTVMMTYuNzUyNiAxMi44NjAxQzE2LjM1NDIgMTIuNDA0OCAxNS42NDU4IDEyLjQwNDggMTUuMjQ3NCAxMi44NjAxTDEwLjQ1MTIgMTguMzQxNUM5Ljg4NTQzIDE4Ljk4ODEgMTAuMzQ0NiAyMCAxMS4yMDM4IDIwWiIgZmlsbD0iIzI5MzU0QyIvPgo8L3N2Zz4K";
export { SvgIconIndexUp as ReactComponent };